import { Box, Typography } from '@mui/material';
import React from 'react';

import { IdeVersionLabel } from '@/shared/components/ui/ide-version-label/ide-version-label';
import { VendorContainer } from '@/shared/components/ui/vendor/vendor.styled';
import { TVendorProps } from '@/shared/components/ui/vendor/vendor.types';
import { useVendor } from '@/shared/hooks/use-vendor/use-vendor';

export const Vendor: React.FC<TVendorProps> = ({ vendorId, ideConfigId }) => {
  const { getVendor } = useVendor();

  const vendor = getVendor({ vendorId })?.name;

  return (
    <VendorContainer direction="row" alignItems="center" minWidth="fit-content">
      <Typography variant="p4">{vendor}</Typography>
      <Box>•</Box>
      <IdeVersionLabel
        vendorId={vendorId}
        ideConfigId={ideConfigId}
        variant="p4"
      />
    </VendorContainer>
  );
};
